import { ModelBase } from "../base"

export class QuestionnaireQuestionContentModel extends ModelBase {
    id = 0;
    question = "";
    rank = 0;


    constructor(params) {
        super();
        this.mapModel(params);
    }
}